/* eslint-disable max-len */
export enum BudgetStatusEnum {
  BUDGET_CREATED = "BUDGET_CREATED",
  BACKOFFICE_PENDING = "BACKOFFICE_PENDING",
  CAR_WORKSHOP_PENDING = "CAR_WORKSHOP_PENDING",
  BUDGET_APPROVAL = "BUDGET_APPROVAL",
  FLEET_ADMIN_APPROVAL = "FLEET_ADMIN_APPROVAL",
  BUDGET_CAR_WORKSHOP_APPROVAL = "BUDGET_CAR_WORKSHOP_APPROVAL",
  BUDGET_CAR_WORKSHOP_NEGOTIATION_APPROVAL = "BUDGET_CAR_WORKSHOP_NEGOTIATION_APPROVAL",
  BUDGET_BACKOFFICE_APPROVAL = "BUDGET_BACKOFFICE_APPROVAL",
  BUDGET_BACKOFFICE_ADMIN_APPROVAL = "BUDGET_BACKOFFICE_ADMIN_APPROVAL",
  BUDGET_FLEET_ADMIN_APPROVAL = "BUDGET_FLEET_ADMIN_APPROVAL",
  BUDGET_BACKOFFICE_NEGOTIATION = "BUDGET_BACKOFFICE_NEGOTIATION",
  BUDGET_AT_AUCTION = "BUDGET_AT_AUCTION",
  BUDGET_PENDING_WORKSHOP_APPROVAL = "BUDGET_PENDING_WORKSHOP_APPROVAL",
  BUDGET_REEVALUATION_WORKSHOP = "BUDGET_REEVALUATION_WORKSHOP",
  BUDGET_PENDING_CLIENT_APPROVAL = "BUDGET_PENDING_CLIENT_APPROVAL",
  BUDGET_CANCELED = "BUDGET_CANCELED",
  BUDGET_DISAPPROVED = "BUDGET_DISAPPROVED",
  BUDGET_APPROVED = "BUDGET_APPROVED",
  VEHICLE_ATTENDANCE_PENDING = "VEHICLE_ATTENDANCE_PENDING",
  VEHICLE_EVALUATION = "VEHICLE_EVALUATION",
  RESCHEDULING = "RESCHEDULING",
  SERVICE_RUNNING = "SERVICE_RUNNING",
  BUDGET_CAR_WORKSHOP_APPROVAL_EXCLUDED_ITEMS = "BUDGET_CAR_WORKSHOP_APPROVAL_EXCLUDED_ITEMS",
  BUDGET_BACKOFFICE_VALIDATION = "BUDGET_BACKOFFICE_VALIDATION",
  BUDGET_BACKOFFICE_CLIENT_APPROVER_SELECTION = "BUDGET_BACKOFFICE_CLIENT_APPROVER_SELECTION"
}
